import { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { Theme, useMediaQuery } from '@mui/material';

import LanguageIcon from '@mui/icons-material/Language';
import { FormattedMessage, useIntl } from 'react-intl';
import messages from './messages';
import languageListMessages from '../LanguageList/messages';
import { useUILanguage } from '../../containers/UILanguage';
import LanguageList from '../LanguageList';

const LanguageButton = () => {
  const intl = useIntl();
  const [isLanguageDialogVisible, toggleLanguageDialogVisibility] =
    useState(false);
  const { locale, setLocale } = useUILanguage();
  const isLargeScreen = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.up('sm')
  );
  return (
    <>
      {isLargeScreen ? (
        <Button
          variant="outlined"
          startIcon={<LanguageIcon />}
          color="inherit"
          onClick={() => {
            toggleLanguageDialogVisibility(true);
          }}
        >
          <FormattedMessage {...languageListMessages[locale]} />
        </Button>
      ) : (
        <IconButton
          aria-label={intl.formatMessage(languageListMessages[locale])}
          color="inherit"
          onClick={() => {
            toggleLanguageDialogVisibility(true);
          }}
          size="large"
        >
          <LanguageIcon />
        </IconButton>
      )}
      <Dialog
        fullWidth
        maxWidth="xs"
        onClose={() => {
          toggleLanguageDialogVisibility(false);
        }}
        aria-labelledby="language-dialog-title"
        open={isLanguageDialogVisible}
      >
        <DialogTitle id="language-dialog-title" sx={{ p: 2 }}>
          <FormattedMessage {...messages.selectYourLanguage} />
        </DialogTitle>
        <LanguageList
          currentLocale={locale}
          onLocaleSelect={(appLocale) => {
            setLocale(appLocale);
            toggleLanguageDialogVisibility(false);
          }}
        />
      </Dialog>
    </>
  );
};

export default LanguageButton;
